/**
 * Checkbox Cell Editor - For boolean values
 */

import React, { useCallback, useEffect } from "react";
import { Check } from "lucide-react";
import CellEditorWrapper from "./CellEditorWrapper";
import { CheckboxCellEditorProps } from "./types";

const CellEditorCheckbox: React.FC<CheckboxCellEditorProps> = ({
  value,
  onChange,
  onSave,
  onCancel,
  isVisible,
  cellRect,
  cellWidth,
}) => {
  // Handle toggle
  const handleToggle = useCallback(() => {
    onChange(!value);
  }, [value, onChange]);

  // Handle keyboard
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      switch (e.key) {
        case "Enter":
        case " ":
          e.preventDefault();
          handleToggle();
          break;
        case "Escape":
          e.preventDefault();
          onCancel();
          break;
      }
    },
    [handleToggle, onCancel]
  );

  // Auto-focus on mount
  useEffect(() => {
    if (isVisible) {
      // Focus the container for keyboard events
    }
  }, [isVisible]);

  return (
    <CellEditorWrapper
      isVisible={isVisible}
      cellRect={cellRect}
      cellWidth={cellWidth}
      onSave={onSave}
      onCancel={onCancel}
      minHeight={44}
      maxHeight={60}
    >
      <div
        tabIndex={0}
        onKeyDown={handleKeyDown}
        className="flex items-center justify-center h-full p-2 focus:outline-none"
      >
        <button
          onClick={handleToggle}
          className={`
            flex items-center justify-center w-8 h-8 rounded-lg border-2 transition-all
            ${
              value
                ? "bg-primary border-primary text-primary-foreground"
                : "bg-card border-border hover:border-muted-foreground"
            }
          `}
        >
          {value && <Check className="h-5 w-5" />}
        </button>
        <span className="ml-3 text-sm text-foreground">
          {value ? "Yes" : "No"}
        </span>
      </div>
    </CellEditorWrapper>
  );
};

export default CellEditorCheckbox;

